import { combineReducers } from "redux";
import { templatesState } from "./templatesReducer";

export const templatesReducers = combineReducers({
    templatesState: templatesState
});
